import { functions, httpsCallable } from '../firebase';

const switchActiveSchoolCallable = httpsCallable(functions, 'switchActiveSchool');

const SELECTABLE_ACCESS_ROLES = new Set(['teacher', 'staff', 'admin']);

export function getSelectableSchoolIds(userData = {}) {
  const ids = [];
  if (typeof userData.assignedSchoolId === 'string' && userData.assignedSchoolId) {
    ids.push(userData.assignedSchoolId);
  }
  Object.entries(userData.schoolRoles || {}).forEach(([schoolId, role]) => {
    if (
      role?.staff === true
      || role?.admin === true
      || SELECTABLE_ACCESS_ROLES.has(role?.accessRole)
    ) {
      ids.push(schoolId);
    }
  });
  return [...new Set(ids)];
}

export async function switchActiveSchool(schoolId) {
  if (typeof schoolId !== 'string' || !schoolId.trim()) {
    throw new Error('Choose a school before switching');
  }
  const result = await switchActiveSchoolCallable({ schoolId });
  return result.data;
}

export default { switchActiveSchool };
